import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, UserRole } from '@shared/types';

interface AuthState {
  user: User | null;
  isLoggedIn: boolean;
  setAuth: (user: User, token: string, refreshToken: string) => void;
  clearAuth: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isLoggedIn: false,
      setAuth: (user, token, refreshToken) => {
        localStorage.setItem('access_token', token);
        localStorage.setItem('refresh_token', refreshToken);
        set({ user, isLoggedIn: true });
      },
      clearAuth: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        set({ user: null, isLoggedIn: false });
      },
      updateUser: (partial) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...partial } : null,
        })),
    }),
    {
      name: 'field-smart-auth',
      // 只持久化 user + isLoggedIn；token 由 client.ts 从 localStorage 读取
      partialize: (state) => ({ user: state.user, isLoggedIn: state.isLoggedIn }),
    }
  )
);

// App 首次加载时，从 localStorage 恢复登录态
export function bootstrapAuth(): void {
  const token = localStorage.getItem('access_token');
  const store = useAuthStore.getState();
  if (token && !store.isLoggedIn) {
    useAuthStore.setState({ isLoggedIn: true });
  }
}

export const hasRole = (user: User | null, roles: UserRole[]): boolean => {
  if (!user) return false;
  return roles.includes(user.role);
};
